import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { JWT_STORAGE_KEY } from '../tenant/auth.service';

/**
 * Adjunta el JWT de tenant (Authorization: Bearer) SOLO a los backends de la
 * casa que lo verifican:
 *
 *  - `apiBaseUrl`: ms-order-product cloud multi-tenant, que lo EMITE.
 *  - `inventoryApiUrl`: ms-smart-inventory, que lo VERIFICA con el mismo
 *    secreto (`FiltroDeJwt`). Sin él, el perfil vertical devolvía 401 y el POS
 *    no podía saber en qué tipo de negocio está (T1, 2026-09-08).
 *  - `coreApiBaseUrl`: ms-core-app, que exige el mismo JWT en todas sus rutas
 *    (`JwtTenantFilter`). Lo usa la caja menor para leer categorías y proveedores (B9.5).
 *
 * NO toca el agente local de hardware (`agentBaseUrl`). Ver docs/40-multitenant.md.
 */
function backendsConJwt(): string[] {
  const env = environment as { apiBaseUrl: string; inventoryApiUrl?: string; coreApiBaseUrl?: string };
  return [env.apiBaseUrl, env.inventoryApiUrl, env.coreApiBaseUrl]
    .filter((u): u is string => typeof u === 'string' && u.startsWith('http'))
    .map((u) => u.replace(/\/+$/, ''));
}

/**
 * La base termina donde termina: exacta, o seguida de «/» o «?» (como `bajoLaBase` del panel, DrDev002 16/10). Con
 * startsWith a secas, `apiBaseUrl` (sin ruta) dejaba pasar «https://…railway.app.otro.com/…» y se llevaba el token.
 */
export function bajoLaBase(url: string, base: string): boolean {
  return url === base || url.startsWith(`${base}/`) || url.startsWith(`${base}?`);
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  if (backendsConJwt().some((base) => bajoLaBase(req.url, base))) {
    let token: string | null = null;
    try {
      token = localStorage.getItem(JWT_STORAGE_KEY);
    } catch {
      token = null;
    }
    if (token) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
  }
  return next(req);
}
